<template>
  <div class="container">
    <form @submit.prevent="submitIdentifyFile">
      <HeadingOne class="-margin-md">ご本人さま確認書類のご提出</HeadingOne>

      <ErrorsAlert :errors="errors"></ErrorsAlert>

      <NoticeBox v-if="sizeError" class="-error _mb-sm-40 _mb-md-60">
        <NoticeHeader>
          <h3 class="heading">以下の内容をご確認ください。</h3>
        </NoticeHeader>
        <NoticeBody>
          <ul>
            <li>
              登録するファイルの合計サイズが超過しています。
            </li>
          </ul>
        </NoticeBody>
      </NoticeBox>
      <slot name="wizard"></slot>

      <section v-if="identity === '01'">
        <HeadingTwo>運転免許証</HeadingTwo>

        <TxtTop></TxtTop>

        <CardBox class="_mb-sm-40 _mb-md-60">
          <CardHeader>運転免許証アップロード時のご確認事項</CardHeader>
          <CardBody>
            <p>以下をご確認ください。</p>
            <ListGroup class="-normal">
              <ListItem class="-normal"
                >お名前、生年月日、ご住所、有効期限、公印、運転免許証番号が記載されているかをご確認ください。</ListItem
              >
              <ListItem class="-normal"
                >裏面に記載がある場合、裏面を必ず撮影してください。</ListItem
              >
              <ListItem class="-normal"
                >本籍地の記載や臓器提供意思表示欄に記載がある場合は、読み取れないように付箋や紙などで隠して撮影してください。</ListItem
              >
            </ListGroup>
          </CardBody>
        </CardBox>

        <IdentityPoint></IdentityPoint>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>運転免許証（表）</HeadingThree>
            <div v-if="identifyFile.file_data1">
              <UploadedImage
                :file-data="identifyFile.file_data1"
                :file-name="identifyFile.file_name1"
                @onDelete="
                  () => {
                    identifyFile.file_data1 = '';
                    identifyFile.file_name1 = '';
                    identifyFile.file_sbt1 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile1"
                doc-type="identify"
                @onDrop="setImgFile1"
                @error="showError"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>運転免許証（裏）</HeadingThree>
            <div v-if="identifyFile.file_data2">
              <UploadedImage
                :file-data="identifyFile.file_data2"
                :file-name="identifyFile.file_name2"
                @onDelete="
                  () => {
                    identifyFile.file_data2 = '';
                    identifyFile.file_name2 = '';
                    identifyFile.file_sbt2 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile2"
                doc-type="identify"
                @onDrop="setImgFile2"
                @error="showError"
              />
            </div>
          </div>
        </div>
      </section>

      <section v-if="identity === '02'">
        <HeadingTwo>運転経歴証明書</HeadingTwo>

        <TxtTop></TxtTop>

        <CardBox class="_mb-sm-40 _mb-md-60">
          <CardHeader>運転経歴証明書アップロード時のご確認事項</CardHeader>
          <CardBody>
            <p>以下をご確認ください。</p>
            <ListGroup class="-normal">
              <ListItem class="-normal"
                >運転経歴証明書は、2012年4月1日以降に交付されているもののみ受付が可能です。</ListItem
              >
              <ListItem class="-normal"
                >お名前、生年月日、ご住所、公印、運転経歴証明書番号が記載されているかをご確認ください。</ListItem
              >
              <ListItem class="-normal"
                >裏面に記載がある場合、裏面を必ず撮影してください。</ListItem
              >
              <ListItem class="-normal"
                >本籍地の記載や臓器提供意思表示欄に記載がある場合は、読み取れないように付箋や紙などで隠して撮影してください。</ListItem
              >
            </ListGroup>
          </CardBody>
        </CardBox>

        <IdentityPoint></IdentityPoint>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>運転経歴証明書（表）</HeadingThree>
            <div v-if="identifyFile.file_data1">
              <UploadedImage
                :file-data="identifyFile.file_data1"
                :file-name="identifyFile.file_name1"
                @onDelete="
                  () => {
                    identifyFile.file_data1 = '';
                    identifyFile.file_name1 = '';
                    identifyFile.file_sbt1 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile3"
                doc-type="identify"
                @onDrop="setImgFile1"
                @error="showError"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>運転経歴証明書（裏）</HeadingThree>
            <div v-if="identifyFile.file_data2">
              <UploadedImage
                :file-data="identifyFile.file_data2"
                :file-name="identifyFile.file_name2"
                @onDelete="
                  () => {
                    identifyFile.file_data2 = '';
                    identifyFile.file_name2 = '';
                    identifyFile.file_sbt2 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile4"
                doc-type="identify"
                @onDrop="setImgFile2"
                @error="showError"
              />
            </div>
          </div>
        </div>
      </section>

      <section v-if="identity === '03'">
        <HeadingTwo>パスポート</HeadingTwo>

        <TxtTop></TxtTop>

        <CardBox class="_mb-sm-40 _mb-md-60">
          <CardHeader>パスポートアップロード時のご確認事項</CardHeader>
          <CardBody>
            <p>顔写真ページ・所持人記入欄</p>
            <div class="row">
              <div class="col-12 col-md-5 _mb-sm-20">
                <img
                  src="@/assets/images/identity/passport.jpg"
                  class="img-fluid _px-sm-10 _px-md-20"
                  alt=""
                />
              </div>
              <div class="col-12 col-md-7">
                <p>以下をご確認ください。</p>
                <ListGroup class="-normal">
                  <ListItem class="-normal"
                    >顔写真入りのページと所持人記入欄を撮影してください。</ListItem
                  >
                  <ListItem class="-normal"
                    >顔写真入りのページに、お名前、生年月日、有効期限、旅券番号が記載されているかをご確認ください。</ListItem
                  >
                  <ListItem class="-normal"
                    >所持人記入欄に、お名前、ご住所が記載されているかをご確認ください。</ListItem
                  >
                </ListGroup>
              </div>
            </div>
          </CardBody>
        </CardBox>

        <IdentityPoint></IdentityPoint>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>パスポート（顔写真入り）</HeadingThree>
            <div v-if="identifyFile.file_data1">
              <UploadedImage
                :file-data="identifyFile.file_data1"
                :file-name="identifyFile.file_name1"
                @onDelete="
                  () => {
                    identifyFile.file_data1 = '';
                    identifyFile.file_name1 = '';
                    identifyFile.file_sbt1 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile5"
                doc-type="identify"
                @onDrop="setImgFile1"
                @error="showError"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>パスポート（所持人記入欄）</HeadingThree>
            <div v-if="identifyFile.file_data2">
              <UploadedImage
                :file-data="identifyFile.file_data2"
                :file-name="identifyFile.file_name2"
                @onDelete="
                  () => {
                    identifyFile.file_data2 = '';
                    identifyFile.file_name2 = '';
                    identifyFile.file_sbt2 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile6"
                doc-type="identify"
                @onDrop="setImgFile2"
                @error="showError"
              />
            </div>
          </div>
        </div>
      </section>

      <section v-if="identity === '04'">
        <HeadingTwo>健康保険 資格確認書</HeadingTwo>

        <TxtTop></TxtTop>

        <CardBox class="_mb-sm-40 _mb-md-60">
          <CardHeader>健康保険 資格確認書アップロード時のご確認事項</CardHeader>
          <CardBody>
            <div class="row">
              <div class="col-12 col-md-5 _mb-sm-20">
                <img
                  src="@/assets/images/identity/insurance.jpg"
                  class="img-fluid _px-sm-10 _px-md-20"
                  alt=""
                />
              </div>
              <div class="col-12 col-md-7">
                <p>以下をご確認ください。</p>
                <ListGroup class="-normal">
                  <ListItem class="-normal"
                    >お名前、生年月日、ご住所が記載されている面を撮影してください。</ListItem
                  >
                  <ListItem class="-normal"
                    >裏面にご住所の記載がある場合、裏面を必ず撮影してください。</ListItem
                  >
                  <ListItem class="-normal"
                    >紙の健康保険 資格確認書の場合は、お名前、生年月日、ご住所が記載されている面をすべて撮影してください。</ListItem
                  >
                  <ListItem class="-normal"
                    >住所が変更されている場合は、下記内容をご確認ください。
                    <ListGroup class="-normal">
                      <ListItem
                        >①住所を自分で書き入れる健康保険 資格確認書：住所欄に新住所が記入されていることをご確認ください。</ListItem
                      >
                      <ListItem
                        >②住所を印字している健康保険 資格確認書：発行元での訂正・訂正印捺印がなされていることをご確認ください。</ListItem
                      >
                    </ListGroup>
                  </ListItem>
                  <ListItem class="-normal"
                    >保険者番号・記号・番号（介護保険の被保険者証および自衛官診療証を含む）、臓器提供意思表示欄に記載がある場合は、読み取れないように付箋や紙などで隠して撮影してください。</ListItem
                  >
                </ListGroup>
              </div>
            </div>
          </CardBody>
        </CardBox>

        <IdentityPoint></IdentityPoint>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>健康保険 資格確認書（表）</HeadingThree>
            <div v-if="identifyFile.file_data1">
              <UploadedImage
                :file-data="identifyFile.file_data1"
                :file-name="identifyFile.file_name1"
                @onDelete="
                  () => {
                    identifyFile.file_data1 = '';
                    identifyFile.file_name1 = '';
                    identifyFile.file_sbt1 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile7"
                doc-type="identify"
                @onDrop="setImgFile1"
                @error="showError"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>健康保険 資格確認書（裏）</HeadingThree>
            <div v-if="identifyFile.file_data2">
              <UploadedImage
                :file-data="identifyFile.file_data2"
                :file-name="identifyFile.file_name2"
                @onDelete="
                  () => {
                    identifyFile.file_data2 = '';
                    identifyFile.file_name2 = '';
                    identifyFile.file_sbt2 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile8"
                doc-type="identify"
                @onDrop="setImgFile2"
                @error="showError"
              />
            </div>
          </div>
        </div>
      </section>

      <section v-if="identity === '05'">
        <HeadingTwo>マイナンバーカード（顔写真付き）</HeadingTwo>

        <TxtTop></TxtTop>

        <CardBox class="_mb-sm-40 _mb-md-60">
          <CardHeader
            >マイナンバーカード（顔写真付き）アップロード時のご確認事項</CardHeader
          >
          <CardBody>
            <div class="row">
              <div class="col-12 col-md-5 _mb-sm-20">
                <img
                  src="@/assets/images/identity/mynumber-card.jpg"
                  class="img-fluid _px-sm-10 _px-md-20"
                  alt=""
                />
              </div>
              <div class="col-12 col-md-7">
                <p>以下をご確認ください。</p>
                <ListGroup class="-normal">
                  <ListItem class="-normal"
                    >お名前、生年月日、ご住所、有効期限が記載されているかをご確認ください。</ListItem
                  >
                  <ListItem class="-normal"
                    >通知カード（写真なし）は本人確認資料として利用はできません。</ListItem
                  >
                  <ListItem class="-normal"
                    >臓器提供意思表示欄に記載がある場合は、読み取れないように付箋や紙などで隠して撮影してください。</ListItem
                  >
                </ListGroup>
              </div>
            </div>
          </CardBody>
        </CardBox>

        <IdentityPoint></IdentityPoint>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>マイナンバーカード（顔写真付き）</HeadingThree>
            <div v-if="identifyFile.file_data1">
              <UploadedImage
                :file-data="identifyFile.file_data1"
                :file-name="identifyFile.file_name1"
                @onDelete="
                  () => {
                    identifyFile.file_data1 = '';
                    identifyFile.file_name1 = '';
                    identifyFile.file_sbt1 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile9"
                doc-type="identify"
                @onDrop="setImgFile1"
                @error="showError"
              />
            </div>
          </div>
        </div>
      </section>

      <section v-if="showSubIdentityType(identity) && subIdentity === '01'">
        <HeadingTwo>住民票の写し</HeadingTwo>

        <CardBox class="_mb-sm-40 _mb-md-60">
          <CardHeader>住民票の写しアップロード時のご確認事項</CardHeader>
          <CardBody>
            <p>以下をご確認ください。</p>
            <ListGroup class="-normal">
              <ListItem class="-normal"
                >発行日から6ヶ月以内かどうかをご確認ください。</ListItem
              >
              <ListItem class="-normal"
                >お名前、生年月日、ご住所、発行日が記載されているかをご確認ください。</ListItem
              >
              <ListItem class="-normal"
                >本籍地、個人番号（マイナンバー）が記載されている場合は、読み取れないように付箋や紙などで隠して撮影してください。</ListItem
              >
            </ListGroup>
          </CardBody>
        </CardBox>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>住民票の写し（ファイル１）</HeadingThree>
            <div v-if="identifyFile.file_data3">
              <UploadedImage
                :file-data="identifyFile.file_data3"
                :file-name="identifyFile.file_name3"
                @onDelete="
                  () => {
                    identifyFile.file_data3 = '';
                    identifyFile.file_name3 = '';
                    identifyFile.file_sbt3 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile10"
                class="_mb-30"
                doc-type="identify"
                @onDrop="setImgFile3"
                @error="showError"
              />
            </div>
          </div>
        </div>
      </section>

      <section v-if="showSubIdentityType(identity) && subIdentity === '02'">
        <HeadingTwo>公的書類</HeadingTwo>

        <CardBox class="_mb-sm-40 _mb-md-60">
          <CardHeader>公的書類アップロード時のご確認事項</CardHeader>
          <CardBody>
            <p>以下のいずれかひとつを撮影してください。</p>

            <p>国税・地方税の領収書または納税証明書/社会保険料の領収書</p>
            <ListGroup class="-normal">
              <ListItem class="-normal"
                >発行日から6ヶ月以内かどうかをご確認ください。</ListItem
              >
              <ListItem class="-normal"
                >お名前、ご住所、発行日が記載されているかをご確認ください。</ListItem
              >
            </ListGroup>
            <p>公共料金の領収書</p>
            <ListGroup class="-normal">
              <ListItem class="-normal"
                >公共料金の領収書は、電気、都市ガス、水道、NHK、固定電話のみ受付が可能です。</ListItem
              >
              <ListItem class="-normal"
                >発行日から6ヶ月以内かどうかをご確認ください。</ListItem
              >
              <ListItem class="-normal"
                >お名前、ご住所、発行日が記載されているかをご確認ください。</ListItem
              >
            </ListGroup>
          </CardBody>
        </CardBox>

        <div class="row">
          <div class="col-12 col-md-6">
            <HeadingThree>公的書類</HeadingThree>
            <div v-if="identifyFile.file_data3">
              <UploadedImage
                :file-data="identifyFile.file_data3"
                :file-name="identifyFile.file_name3"
                @onDelete="
                  () => {
                    identifyFile.file_data3 = '';
                    identifyFile.file_name3 = '';
                    identifyFile.file_sbt3 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile11"
                class="_mb-30"
                doc-type="identify"
                @onDrop="setImgFile3"
                @error="showError"
              />
            </div>
          </div>
        </div>
      </section>

      <section
        v-if="
          showProofNationalityType(nationality) && proofNationality === '03'
        "
      >
        <HeadingTwo>在留カード</HeadingTwo>

        <CardBox class="_mb-sm-40 _mb-md-60">
          <CardHeader>在留カードアップロード時のご確認事項</CardHeader>
          <CardBody>
            <p>以下をご確認ください。</p>
            <ListGroup class="-normal">
              <ListItem class="-normal"
                >お名前、生年月日、ご住所、有効期限、公印、在留カード番号が記載されているかをご確認ください。</ListItem
              >
              <ListItem class="-normal"
                >裏面に記載がある場合、裏面を必ず撮影してください。</ListItem
              >
            </ListGroup>
          </CardBody>
        </CardBox>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>在留カード（表）</HeadingThree>
            <div v-if="identifyFile.file_data4">
              <UploadedImage
                :file-data="identifyFile.file_data4"
                :file-name="identifyFile.file_name4"
                @onDelete="
                  () => {
                    identifyFile.file_data4 = '';
                    identifyFile.file_name4 = '';
                    identifyFile.file_sbt4 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile12"
                doc-type="identify"
                @onDrop="setImgFile4"
                @error="showError"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>在留カード（裏）</HeadingThree>
            <div v-if="identifyFile.file_data5">
              <UploadedImage
                :file-data="identifyFile.file_data5"
                :file-name="identifyFile.file_name5"
                @onDelete="
                  () => {
                    identifyFile.file_data5 = '';
                    identifyFile.file_name5 = '';
                    identifyFile.file_sbt5 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile13"
                doc-type="identify"
                @onDrop="setImgFile5"
                @error="showError"
              />
            </div>
          </div>
        </div>
      </section>

      <section
        v-if="
          showProofNationalityType(nationality) && proofNationality === '04'
        "
      >
        <HeadingTwo>特別永住者証明書</HeadingTwo>

        <CardBox class="_mb-sm-40 _mb-md-60">
          <CardHeader>特別永住者証明書アップロード時のご確認事項</CardHeader>
          <CardBody>
            <p>以下をご確認ください。</p>
            <ListGroup class="-normal">
              <ListItem class="-normal"
                >お名前、生年月日、ご住所、有効期限、公印、特別永住者証明書番号が記載されているかをご確認ください。</ListItem
              >
              <ListItem class="-normal"
                >裏面に記載がある場合、裏面を必ず撮影してください。</ListItem
              >
            </ListGroup>
          </CardBody>
        </CardBox>

        <div class="row">
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>特別永住者証明書（表）</HeadingThree>
            <div v-if="identifyFile.file_data4">
              <UploadedImage
                :file-data="identifyFile.file_data4"
                :file-name="identifyFile.file_name4"
                @onDelete="
                  () => {
                    identifyFile.file_data4 = '';
                    identifyFile.file_name4 = '';
                    identifyFile.file_sbt4 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile14"
                doc-type="identify"
                @onDrop="setImgFile4"
                @error="showError"
              />
            </div>
          </div>
          <div class="col-12 col-md-6 _mb-sm-30 _mb-md-50">
            <HeadingThree>特別永住者証明書（裏）</HeadingThree>
            <div v-if="identifyFile.file_data5">
              <UploadedImage
                :file-data="identifyFile.file_data5"
                :file-name="identifyFile.file_name5"
                @onDelete="
                  () => {
                    identifyFile.file_data5 = '';
                    identifyFile.file_name5 = '';
                    identifyFile.file_sbt5 = '';
                  }
                "
              />
            </div>
            <div v-else>
              <UploadImage
                id="setImgFile15"
                doc-type="identify"
                @onDrop="setImgFile5"
                @error="showError"
              />
            </div>
          </div>
        </div>
      </section>
      <BtngroupDouble class="-margin-lg">
        <template #main>
          <BtnMain class="-main" @click.prevent="submitIdentifyFile">
            確認へ進む
          </BtnMain>
        </template>
        <template #back>
          <BtnBack class="-back -sm" @click.prevent="goBack"> 戻る </BtnBack>
        </template>
      </BtngroupDouble>
    </form>
  </div>
</template>

<script>
import { goToErrorPage, scrollTop } from "@/utils/Other";
import { initCredentials } from "@/utils/Auth";
import {
  validateEditIdentifyFileLambdaInvoke,
  getUserDataLambdaInvoke,
} from "@/utils/LambdaHelper";
import {
  fileUploadCreated,
  showSubIdentityType,
  showProofNationalityType,
  getIdentityFileSbt,
  getSubIdentityFileSbt,
  getNationalityFileSbt,
} from "@/utils/FileUpload";

import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import HeadingThree from "@/components/heading/HeadingThree";
import ErrorsAlert from "@/components/alert/ErrorsAlert";
import BtnMain from "@/components/button/BtnMain";
import BtnBack from "@/components/button/BtnBack";
import BtngroupDouble from "@/components/button/BtngroupDouble";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardBody from "@/components/card/CardBody";
import UploadImage from "@/components/upload/UploadImage";
import UploadedImage from "@/components/upload/UploadedImage";
import IdentityPoint from "@/components/upload/IdentityPoint";
import TxtTop from "@/components/upload/TxtTop";
import NoticeBox from "@/components/box/NoticeBox";
import NoticeHeader from "@/components/box/NoticeHeader";
import NoticeBody from "@/components/box/NoticeBody";

export default {
  name: "IdentifySelect",
  components: {
    TxtTop,
    IdentityPoint,
    CardBody,
    CardHeader,
    CardBox,
    HeadingOne,
    HeadingTwo,
    HeadingThree,
    BtngroupDouble,
    ErrorsAlert,
    BtnMain,
    BtnBack,
    ListGroup,
    ListItem,
    UploadImage,
    UploadedImage,
    NoticeHeader,
    NoticeBox,
    NoticeBody,
  },
  props: {
    previousPageId: { type: String, default: "" },
    nextPageId: { type: String, default: "" },
  },
  setup() {
    return {
      fileUploadCreated,
      showSubIdentityType,
      showProofNationalityType,
      getIdentityFileSbt,
      getSubIdentityFileSbt,
      getNationalityFileSbt,
    };
  },
  data() {
    return {
      identity: this.$route.query.identity,
      subIdentity: this.$route.query.subIdentity,
      nationality: this.$route.query.nationality,
      proofNationality: this.$route.query.proofNationality,
      isDisabled: false,
      files: true,
      sizeError: false,
      errors: {},
      identifyFile: {
        identity: this.$route.query.identity,
        subIdentity: this.$route.query.subIdentity,
        nationality: this.$route.query.nationality,
        proofNationality: this.$route.query.proofNationality,
        processing_type: "1",
        file_name1: "",
        file_data1: "",
        file_sbt1: "",
        file_name2: "",
        file_data2: "",
        file_sbt2: "",
        file_name3: "",
        file_data3: "",
        file_sbt3: "",
        file_name4: "",
        file_data4: "",
        file_sbt4: "",
        file_name5: "",
        file_data5: "",
        file_sbt5: "",
        file_name6: "",
        file_data6: "",
        file_sbt6: "",
      },
    };
  },
  created() {
    this.fileUploadCreated();
    this.checkQueryParam();
  },
  mounted() {
    try {
      getUserDataLambdaInvoke(this.files)
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.identifyFile, key)) {
              if (["file_name6", "file_data6", "file_sbt6"].indexOf(key) > -1) {
                // file6は使わない
                continue;
              }
              if (this.identity === "05") {
                // マイナンバーカードは表のみ
                if (
                  ["file_name2", "file_data2", "file_sbt2"].indexOf(key) > -1
                ) {
                  continue;
                }
              }
              if (this.identity !== "04" && this.identity !== "05") {
                // 健康保険 資格確認書とマイナンバーカード以外は住民票、公的書類は提出しない
                if (
                  ["file_name3", "file_data3", "file_sbt3"].indexOf(key) > -1
                ) {
                  continue;
                }
              }
              if (this.nationality !== "02") {
                // 日本国籍の人は、在留カードと永住者証明書は不要
                if (
                  [
                    "file_name4",
                    "file_data4",
                    "file_sbt4",
                    "file_name5",
                    "file_data5",
                    "file_sbt5",
                  ].indexOf(key) > -1
                ) {
                  continue;
                }
              }
              this.identifyFile[key] = res[key];
            }
          }
          if (res["file_sbt1"] !== this.getIdentityFileSbt(this.identity)) {
            this.identifyFile.file_name1 = "";
            this.identifyFile.file_data1 = "";
            this.identifyFile.file_sbt1 = "";
          }
          if (res["file_sbt2"] !== this.getIdentityFileSbt(this.identity)) {
            this.identifyFile.file_name2 = "";
            this.identifyFile.file_data2 = "";
            this.identifyFile.file_sbt2 = "";
          }
          if (
            res["file_sbt3"] !== this.getSubIdentityFileSbt(this.subIdentity)
          ) {
            this.identifyFile.file_name3 = "";
            this.identifyFile.file_data3 = "";
            this.identifyFile.file_sbt3 = "";
          }
          if (
            res["file_sbt4"] !==
            this.getNationalityFileSbt(this.proofNationality)
          ) {
            this.identifyFile.file_name4 = "";
            this.identifyFile.file_data4 = "";
            this.identifyFile.file_sbt4 = "";
          }
          if (
            res["file_sbt5"] !==
            this.getNationalityFileSbt(this.proofNationality)
          ) {
            this.identifyFile.file_name5 = "";
            this.identifyFile.file_data5 = "";
            this.identifyFile.file_sbt5 = "";
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
  methods: {
    submitIdentifyFile: function () {
      const bytes =
        this.identifyFile.file_data1.length +
        this.identifyFile.file_data2.length +
        this.identifyFile.file_data3.length +
        this.identifyFile.file_data4.length +
        this.identifyFile.file_data5.length;

      this.sizeError = bytes > 6144000; // 6000KB
      if (this.sizeError) {
        scrollTop();
        return;
      }

      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        this.errors = {};
        this.identifyFile.processing_type = "1";
        this.checkQueryParam();
        initCredentials()
          .then(() => {
            validateEditIdentifyFileLambdaInvoke(this.identifyFile)
              .then((res) => {
                this.errors = {};
                if (res.errors) {
                  for (let e in res.errors) {
                    let key = e;
                    if (e.indexOf("file_data") !== -1) {
                      if (e === "file_data1" || e === "file_data2") {
                        key += "_" + this.identity;
                      } else if (e === "file_data3") {
                        key += "_" + this.subIdentity;
                      } else if (e === "file_data4" || e === "file_data5") {
                        key += "_" + this.proofNationality;
                      }
                      this.errors[key] = res.errors[e];
                      if (this.errors[key].length > 0) {
                        this.errors[key][0] = this.errors[key][0].replace(
                          "empty",
                          "unselect"
                        );
                      }
                    }
                  }
                  scrollTop();
                  this.isDisabled = false;
                } else {
                  let queryParam = {
                    identity: this.identity || "00",
                    subIdentity: this.subIdentity || "00",
                    nationality: this.nationality || "02",
                    proofNationality: this.proofNationality || "00",
                  };
                  this.$router.push({
                    name: this.nextPageId,
                    query: queryParam,
                  });
                }
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    goBack: function () {
      try {
        let queryParam = {
          identity: this.identity || "00",
          subIdentity: this.subIdentity || "00",
          nationality: this.nationality || "02",
          proofNationality: this.proofNationality || "00",
        };
        this.$router.push({ name: this.previousPageId, query: queryParam });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    checkQueryParam() {
      try {
        if (
          window.__PRERENDER_INJECTED &&
          window.__PRERENDER_INJECTED.isPrerendering
        ) {
          // ビルド時の静的ファイル生成時はチェックしない
          return;
        }
        if (
          ["01", "02", "03", "04", "05"].indexOf(this.$route.query.identity) ===
          -1
        ) {
          this.$router.push({ name: this.previousPageId });
        }
        if (["04", "05"].indexOf(this.$route.query.subIdentity) !== -1) {
          if (["01", "02"].indexOf(this.$route.query.subIdentity) === -1) {
            this.$router.push({ name: this.previousPageId });
          }
        }
        if (["01", "02"].indexOf(this.$route.query.nationality) === -1) {
          this.$router.push({ name: this.previousPageId });
        }
        if (["02"].indexOf(this.$route.query.nationality) !== -1) {
          if (["03", "04"].indexOf(this.$route.query.proofNationality) === -1) {
            this.$router.push({ name: this.previousPageId });
          }
        }
      } catch (e) {
        goToErrorPage(e);
      }
    },
    showError(error) {
      this.errors = error;
    },
    setImgFile1(fileData, fileName) {
      this.identifyFile.file_data1 = fileData;
      this.identifyFile.file_name1 = fileName;
      this.identifyFile.file_sbt1 = this.getIdentityFileSbt(this.identity);
    },
    setImgFile2(fileData, fileName) {
      this.identifyFile.file_data2 = fileData;
      this.identifyFile.file_name2 = fileName;
      this.identifyFile.file_sbt2 = this.getIdentityFileSbt(this.identity);
    },
    setImgFile3(fileData, fileName) {
      this.identifyFile.file_data3 = fileData;
      this.identifyFile.file_name3 = fileName;
      this.identifyFile.file_sbt3 = this.getSubIdentityFileSbt(
        this.subIdentity
      );
    },
    setImgFile4(fileData, fileName) {
      this.identifyFile.file_data4 = fileData;
      this.identifyFile.file_name4 = fileName;
      this.identifyFile.file_sbt4 = this.getNationalityFileSbt(
        this.proofNationality
      );
    },
    setImgFile5(fileData, fileName) {
      this.identifyFile.file_data5 = fileData;
      this.identifyFile.file_name5 = fileName;
      this.identifyFile.file_sbt5 = this.getNationalityFileSbt(
        this.proofNationality
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

:deep(.dropImage) {
  border: 1px #999 dashed;
}
</style>
